<template>
    <div>
        <div class="contDiv">
        <table>
            <tr>
                <td>会议名称</td>
                <td>{{meetingDTO.name}}</td>
            </tr>
            <tr>
                <td>举办时间</td>
                <td>{{meetingDTO.startDate | limitDate}}</td>
            </tr>
            <tr>
                <td>举办地点</td>
                <td>{{meetingDTO.provinceName}}</td>
            </tr>
        </table>
        <table>
            <tr>
                <td>参会人姓名</td>
                <td>{{userInfo.name}}</td>
            </tr>
            <tr>
                <td>手机号码</td>
                <td>{{userInfo.mobile}}</td>
            </tr>
            <tr>
                <td>电子邮箱</td>
                <td>{{userInfo.email}}</td>
            </tr>
        </table>
         <van-divider>参会信息</van-divider>
        </div>
        <div v-if="meetingPlaceDTOs.length>0" class="fieDiv">
            <van-field
            readonly
            clickable
            name="picker"
            :value="placeName"
            label="选择分会场"
            placeholder="点击选择分会场"
            @click="showPicker = true"
            />
            <van-popup v-model="showPicker" position="bottom">
            <van-picker
                show-toolbar
                :columns="meetingPlaceDTOs"
                @confirm="onConfirm"
                @cancel="showPicker = false"
            />
            </van-popup>
            <van-field name="oralReport" label="口头报告">
                <template #input>
                    <van-radio-group v-model="oralReport" direction="horizontal">
                    <van-radio name="1">是</van-radio>
                    <van-radio name="2">否</van-radio>
                    </van-radio-group>
                </template>
            </van-field>
             <van-field v-if="oralReport == '1'" v-model="oralName" label="报告人姓名" placeholder="请输入报告人姓名" />
             <van-field v-if="oralReport == '1'" v-model="oralTitle" label="报告人职称" placeholder="请输入报告人职称" />
             <van-field v-if="oralReport == '1'" v-model="oralCompany" label="报告人单位" placeholder="请输入报告人单位" />
        </div>
        <div style="padding:0 20px; margin:20px 0"><van-button type="primary" block @click="next">下一步</van-button></div>
        
    </div>
</template>

<script>
import { Field, Button, Checkbox, Toast,Form,Popup,Picker,Divider,Icon,RadioGroup,Radio } from "vant";
import {getMeetingDetail ,getUser,registerHydro} from "@/api/dictionary";

export default {
  data() {
    return {
        value: '',
        columns: [  {"keyId":2,"text":"测试1"}, {"keyId":10,"text":"测试2"},],
        showPicker: false,
        oralReport: '1',
        oralName:'',
        oralTitle:'',
        oralCompany:'',
        meetingDTO:{},
        userInfo:{},
        meetingPlaceDTOs:[],
        params:{
          placeId:'',
          meetingId:'',
          memberId:'',
          oralReport:'',
          oralName:'',
          oralTitle:'',
          oralCompany:'',
        },
        placeName:''
    };
  },
  components: {
    [Field.name]: Field,
    [Button.name]: Button,
    [Checkbox.name]: Checkbox,
    [Form.name]:Form,
    [Popup.name]:Popup,
    [Picker.name]:Picker,
    [Divider.name]:Divider,
    [Icon.name]:Icon,
    [RadioGroup.name]:RadioGroup,
    [Radio.name]:Radio,
  },
  computed:{
		id() {
	      return this.$route.query && this.$route.query.meetingId;
	    },
	},
  methods: {
    onConfirm(value) {
      this.params.placeId = value.id;
      this.placeName = value.name;
      this.showPicker = false;
    },
    next() {
      if(new Date(this.meetingDTO.registerEndDate) < new Date()){
          Toast.fail("不在报名范围!");
         return
      }
    return;
      let params = this.params;
      params.memberId = this.userInfo.id;
      params.meetingId = this.id;
      params.oralReport =this.oralReport
      params.oralName = this.oralName
      params.oralTitle = this.oralTitle
      params.oralCompany = this.oralTitle
      if(this.meetingPlaceDTOs.length > 0 && !this.params.placeId){
            this.$tips.error("分会场不能为空");
            return;
      }
      registerHydro(params).then(res => {
        if (res.success) {
         this.$emit("sendActive", 1);
        } else {
          Toast.fail("注册失败!");
        }
      });
    },
	  getUserInfo(){
      getUser().then(res=>{
        if (res.success) {
          this.userInfo = res.result;
        
        }
      })
	  },
  },
  mounted(){  
      getMeetingDetail({meetingId:this.id})
      .then(res =>{
        this.meetingDTO = res.result.meetingDTO;
        this.meetingPlaceDTOs = res.result.meetingPlaceDTOs;
        this.meetingPlaceDTOs.map(item => item.text = item.name)
      })
    this.getUserInfo();
      
  }
};
</script>

<style lang="less" scoped>
table{width:100%;text-align:center;border-collapse:collapse;border-spacing:1;border-spacing:0; margin-top: -1px;}
table td{word-break: break-all; word-wrap:break-word;border:1px solid #eee; padding: 10px 15px; line-height: 24px;
font-size: 14px; text-align: left; vertical-align: middle;}
table td:nth-child(1){ width: 32%; background: #f6f6f6; text-align:center;}
.contDiv{ padding: 0 20px;}
/deep/.van-divider{ font-size: 15px;}
.fieDiv /deep/span{ font-size: 14px; }
</style>
